import { createAction, props } from "@ngrx/store";
import { IReqGenerateKeyRes } from "../../models/request-genearate-key.model";

export const updateActiveStatus = createAction(
  "[Agent] Update Agent Status",
  props<{ userId: string; status: string }>()
);

export const updateActiveStatusSuccess = createAction(
  "[Agent] Update Agent Status Success",
  props<{ response: IReqGenerateKeyRes }>()
);

export const updateActiveStatusFailure = createAction(
  "[Agent] Update Agent Status Failure",
  props<{ error: any }>()
);
export const clearStoreActiveStatus = createAction(
  "[Agent] Clear Active Status Store"
);
